import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: "localhost",
  projectId: process.env.REACT_APP_PROJECT_ID,
});

export const auth = firebase.auth();
